import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { GlobalProductsModel } from "@NA/Services/ADIChoiceGlobalProductsService";
import AdiChoiceGlobalProductsState from "@NA/Store/Data/ADIChoiceGlobalProductsState";
import { Draft } from "immer";

const initialState: AdiChoiceGlobalProductsState = {
    isLoading: false,
    globalProducts: undefined,
    globalProductInfosByLineId: undefined,
};

const reducer = {
    "Custom/LoadGlobalProducts": (
        draft: Draft<AdiChoiceGlobalProductsState>,
        action: { result: GlobalProductsModel },
    ) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteGlobalProducts": (
        draft: Draft<AdiChoiceGlobalProductsState>,
        action: { globalProducts: { result: GlobalProductsModel } },
    ) => {
        draft.isLoading = false;
        draft.globalProducts = action?.globalProducts.result.products;
    },
    "Custom/GlobalProduct/SetRealtimePricing": (
        draft: Draft<AdiChoiceGlobalProductsState>,
        action: { globalProductInfosByLineId: { productInfosByLineId: SafeDictionary<ProductInfo> } },
    ) => {
        draft.globalProductInfosByLineId = action.globalProductInfosByLineId.productInfosByLineId;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
